import { createStore } from './main.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { State } from './types';

export const store = createStore();
